/**
 * Admin Portal Constants
 * Centralized constants for admin functionality
 */

import { supabase } from '../lib/supabaseClient';

export const MASTER_ADMIN_WALLET = '0xf8Ca9dA64Bb500C4C4395f7Bb987De3e77883130';

/**
 * Check if a wallet address is an admin (checks database with fallback)
 */
export async function isAdminWallet(address: string | undefined): Promise<boolean> {
  if (!address) return false;
  
  // First check if it's the master admin (immediate access)
  if (address.toLowerCase() === MASTER_ADMIN_WALLET.toLowerCase()) {
    return true;
  }
  
  // Then check database for other admins
  try {
    const { data, error } = await supabase.rpc('is_admin', {
      p_wallet_address: address.toLowerCase(),
    });

    if (error) {
      console.error('Error checking admin status:', error);
      return false;
    }

    return data as boolean;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
}

/**
 * Check if a wallet address is the master admin
 */
export function isMasterAdmin(address: string | undefined): boolean {
  if (!address) return false;
  return address.toLowerCase() === MASTER_ADMIN_WALLET.toLowerCase();
}

/**
 * Synchronous check for master admin (for immediate UI decisions)
 */
export function isMasterAdminSync(address: string | undefined): boolean {
  if (!address) return false;
  return address.toLowerCase() === MASTER_ADMIN_WALLET.toLowerCase();
}

